'use client';

import { PropsWithChildren, useEffect } from 'react';
import { Modal } from '@/ui/common/Modal/Modal';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { LightboxFooter, LightboxHeader } from './core';
import { useCartStore } from '@/service/state/Cart/useCartStore';
import { useSearchParams } from 'next/navigation';

type TLightboxProps = PropsWithChildren & {
    partnerId: string;
    partnerSlug: string;
    partnerWebsite: string;
    partnerLogoSrc: string;
    phoneNumber: string;
    isLightframePage: boolean;
};

export const Lightbox = ({
    partnerId,
    partnerSlug,
    partnerWebsite,
    partnerLogoSrc,
    phoneNumber,
    isLightframePage,
    children,
}: TLightboxProps) => {
    const { setIsLightframePage } = usePartnerStore();
    const cartItems = useCartStore((state) => state.cart?.cart_items?.length);
    const query = useSearchParams();
    const noClose = query.get('noClose');

    useEffect(() => {
        setIsLightframePage(isLightframePage);
        document.body.style.backgroundColor = 'transparent';
    }, [isLightframePage, setIsLightframePage]);

    return (
        <Modal
            popupClassName="lg:p-0 md:p-0 p-0 h-full md:w-[96vw] md:h-[96vh] max-w-[1470px] 2xl:max-w-[1470px] lg:max-w-[1470px] md:max-w-[1470px] shadow-lightPopup dark:shadow-darkPopup rounded-none rounded-t-2xl md:rounded-2xl"
            closerClassName="bg-dark-2 hover:bg-dark-3 hover:shadow-dark darken md:w-12 md:h-12"
            closeButtonClassName="hidden md:block top-2 right-3 z-[60]"
            isOpen
            id="main_popup"
            closeModal={
                noClose !== '1'
                    ? () => {
                          window.parent.postMessage(
                              {
                                  type: 'wr_close_area',
                                  items: cartItems || 0,
                                  partnerId,
                              },
                              '*'
                          );
                      }
                    : undefined
            }
            useCloseBtnOnly
        >
            <div
                id="lightframe-container"
                className="custom-scroll h-full max-h-screen overflow-y-scroll dark:bg-blue-main"
            >
                <LightboxHeader
                    partnerId={partnerId}
                    partnerSlug={partnerSlug}
                    partnerWebsite={partnerWebsite}
                    partnerLogoSrc={partnerLogoSrc}
                    phoneNumber={phoneNumber}
                />
                <div className="h-full">
                    {children}
                    <LightboxFooter />
                </div>
            </div>
        </Modal>
    );
};
